import http from "./http.js";

/********* 接送机 **********/
export const carDemands = {
    // 接送机需求列表
    getList: function(params) {
        return http.postRequestToken("/uc/meeting/carDemands/user/list", params)
    },
    // 接送机需求详情
    detail: function(id) {
        return http.postRequestToken("/uc/meeting/carDemands/user/detail", {
            id: id
        })
    },
    // 新增接送机需求
    add: function(params) {
        return http.postRequestToken("/uc/meeting/carDemands/user/add", params)
    },
    // 修改接送机需求
    edit: function(params) {
        return http.postRequestToken("/uc/meeting/carDemands/user/update", params)
    },
    // 取消接送机需求
    cancel: function(id) {
        return http.postRequestToken("/uc/meeting/carDemands/user/cancel", {
            id: id
        })
    }
}

/********* 酒店 **********/
export const hotelDemand = {
    // 酒店需求列表
    getList: function(params) {
        return http.postRequestToken("/uc/meeting/hotels/hotelDemand/list", params)
    },
    // 酒店需求详情
    detail: function(id) {
        return http.postRequestToken("/uc/meeting/hotels/hotelDemand/detail", {
            id: id
        })
    },
    // 新增酒店需求
    add: function(params) {
        return http.postRequestToken("/uc/meeting/hotels/hotelDemand/add", params)
    },
    // 修改酒店需求
    edit: function(params) {
        return http.postRequestToken("/uc/meeting/hotels/hotelDemand/update", params)
    },
    // 取消酒店需求
    cancel: function(id) {
        return http.postRequestToken("/uc/meeting/hotels/hotelDemand/cancel", {
            id: id
        })
    }
}

/********* 行程信息补充 **********/
export const travelsDemand = {
    // 行程列表
    getList: function(params) {
        return http.postRequestToken("/uc/meeting/travels/list", params)
    },
    // 行程详情
    detail: function(mainId, guestId) {
        return http.postRequestToken("/uc/meeting/travels/detail", {
            mainId,
            guestId
        })
    },
    // 新增行程
    add: function(params) {
        return http.postRequestToken("/uc/meeting/travels/add", params)
    },
    // 修改行程
    edit: function(params) {
        return http.postRequestToken("/uc/meeting/travels/update", params)
    }
}